import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableReferralFragment = { readonly __typename?: 'SyncableReferral', readonly id: string, readonly facilityId?: string | null, readonly freeTextFacility?: string | null, readonly reasons: ReadonlyArray<string>, readonly notes?: string | null, readonly patientId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncReferralPullQueryVariables = Types.Exact<{
  input: Types.PullReferralInput;
}>;


export type SyncReferralPullQuery = { readonly __typename?: 'Query', readonly pullReferral: { readonly __typename?: 'PullReferralResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableReferral', readonly id: string, readonly facilityId?: string | null, readonly freeTextFacility?: string | null, readonly reasons: ReadonlyArray<string>, readonly notes?: string | null, readonly patientId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncReferralPushMutationVariables = Types.Exact<{
  input: Types.PushReferralInput;
}>;


export type SyncReferralPushMutation = { readonly __typename?: 'Mutation', readonly pushReferral: { readonly __typename?: 'PushReferralResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableReferral', readonly id: string, readonly facilityId?: string | null, readonly freeTextFacility?: string | null, readonly reasons: ReadonlyArray<string>, readonly notes?: string | null, readonly patientId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableReferralFragmentDoc = gql`
    fragment WholeSyncableReferral on SyncableReferral {
  id
  facilityId
  freeTextFacility
  reasons
  notes
  patientId
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncReferralPullDocument = gql`
    query SyncReferralPull($input: PullReferralInput!) {
  pullReferral(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableReferral
    }
  }
}
    ${WholeSyncableReferralFragmentDoc}`;

/**
 * __useSyncReferralPullQuery__
 *
 * To run a query within a React component, call `useSyncReferralPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncReferralPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncReferralPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncReferralPullQuery(baseOptions: Apollo.QueryHookOptions<SyncReferralPullQuery, SyncReferralPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncReferralPullQuery, SyncReferralPullQueryVariables>(SyncReferralPullDocument, options);
      }
export function useSyncReferralPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncReferralPullQuery, SyncReferralPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncReferralPullQuery, SyncReferralPullQueryVariables>(SyncReferralPullDocument, options);
        }
export type SyncReferralPullQueryHookResult = ReturnType<typeof useSyncReferralPullQuery>;
export type SyncReferralPullLazyQueryHookResult = ReturnType<typeof useSyncReferralPullLazyQuery>;
export type SyncReferralPullQueryResult = Apollo.QueryResult<SyncReferralPullQuery, SyncReferralPullQueryVariables>;
export const SyncReferralPushDocument = gql`
    mutation SyncReferralPush($input: PushReferralInput!) {
  pushReferral(input: $input) {
    rows {
      ...WholeSyncableReferral
    }
  }
}
    ${WholeSyncableReferralFragmentDoc}`;
export type SyncReferralPushMutationFn = Apollo.MutationFunction<SyncReferralPushMutation, SyncReferralPushMutationVariables>;

/**
 * __useSyncReferralPushMutation__
 *
 * To run a mutation, you first call `useSyncReferralPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncReferralPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncReferralPushMutation, { data, loading, error }] = useSyncReferralPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncReferralPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncReferralPushMutation, SyncReferralPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncReferralPushMutation, SyncReferralPushMutationVariables>(SyncReferralPushDocument, options);
      }
export type SyncReferralPushMutationHookResult = ReturnType<typeof useSyncReferralPushMutation>;
export type SyncReferralPushMutationResult = Apollo.MutationResult<SyncReferralPushMutation>;
export type SyncReferralPushMutationOptions = Apollo.BaseMutationOptions<SyncReferralPushMutation, SyncReferralPushMutationVariables>;